/**
 * API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { MobileChallengeCommandResult } from '../model/mobileChallengeCommandResult';
import { MobileSignInCommandResult } from '../model/mobileSignInCommandResult';
import { ValidationProblemDetails } from '../model/validationProblemDetails';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class MobileService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param loginHint 
     * @param sandboxCode 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public mobileSignInGet(loginHint?: string, sandboxCode?: string, observe?: 'body', reportProgress?: boolean): Observable<MobileChallengeCommandResult>;
    public mobileSignInGet(loginHint?: string, sandboxCode?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MobileChallengeCommandResult>>;
    public mobileSignInGet(loginHint?: string, sandboxCode?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MobileChallengeCommandResult>>;
    public mobileSignInGet(loginHint?: string, sandboxCode?: string, observe: any = 'body', reportProgress = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (loginHint !== undefined && loginHint !== null) {
            queryParameters = queryParameters.set('LoginHint', <any>loginHint);
        }
        if (sandboxCode !== undefined && sandboxCode !== null) {
            queryParameters = queryParameters.set('SandboxCode', <any>sandboxCode);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<MobileChallengeCommandResult>('get',`${this.basePath}/Mobile/SignIn`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param externalId 
     * @param sandboxCode 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public mobileSignInPost(externalId?: string, sandboxCode?: string, observe?: 'body', reportProgress?: boolean): Observable<MobileSignInCommandResult>;
    public mobileSignInPost(externalId?: string, sandboxCode?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MobileSignInCommandResult>>;
    public mobileSignInPost(externalId?: string, sandboxCode?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MobileSignInCommandResult>>;
    public mobileSignInPost(externalId?: string, sandboxCode?: string, observe: any = 'body', reportProgress = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (externalId !== undefined && externalId !== null) {
            queryParameters = queryParameters.set('ExternalId', <any>externalId);
        }
        if (sandboxCode !== undefined && sandboxCode !== null) {
            queryParameters = queryParameters.set('SandboxCode', <any>sandboxCode);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<MobileSignInCommandResult>('post',`${this.basePath}/Mobile/SignIn`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param phoneNumber 
     * @param email 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public mobileSignUpPost(phoneNumber?: string, email?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public mobileSignUpPost(phoneNumber?: string, email?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public mobileSignUpPost(phoneNumber?: string, email?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public mobileSignUpPost(phoneNumber?: string, email?: string, observe: any = 'body', reportProgress = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (phoneNumber !== undefined && phoneNumber !== null) {
            queryParameters = queryParameters.set('PhoneNumber', <any>phoneNumber);
        }
        if (email !== undefined && email !== null) {
            queryParameters = queryParameters.set('Email', <any>email);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('post',`${this.basePath}/Mobile/SignUp`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
